import { createSlice } from "@reduxjs/toolkit";
import {
  setLoadingState,
  setSuccessState,
  setFailureState,
  initialApiState,
} from "@Src/redux/utils/apiHelpers";

export const initialState = {
  contactMethods: {
    fetchApi: { ...initialApiState },
    createApi: { ...initialApiState },
    updateApi: { ...initialApiState },
    deleteApi: { ...initialApiState },
    data: [],
  },
};

const contactMethodsSlice = createSlice({
  name: "contactMethods",
  initialState,
  reducers: {
    fetchContactMethods(state) {
      setLoadingState(state.contactMethods.fetchApi);
    },
    fetchContactMethodsSuccess(state, action) {
      state.contactMethods.data = setSuccessState(state.contactMethods.fetchApi, action.payload[0]);
    },
    fetchContactMethodsFailure(state, action) {
      setFailureState(state.contactMethods.fetchApi, action.payload, null);
    },
    createContactMethods(state) {
      setLoadingState(state.contactMethods.createApi);
    },
    createContactMethodsSuccess(state, action) {
      state.contactMethods.data = setSuccessState(
        state.contactMethods.createApi,
        action.payload[0],
      );
    },
    createContactMethodsFailure(state, action) {
      setFailureState(
        state.contactMethods.createApi,
        action.payload.data,
        action.payload.statusText,
      );
    },
    updateContactMethods(state) {
      setLoadingState(state.contactMethods.updateApi);
    },
    updateContactMethodsSuccess(state, action) {
      state.contactMethods.data = setSuccessState(
        state.contactMethods.updateApi,
        action.payload[0],
      );
    },
    updateContactMethodsFailure(state, action) {
      setFailureState(
        state.contactMethods.updateApi,
        action.payload.data,
        action.payload.statusText,
      );
    },
    deleteContactMethods(state) {
      setLoadingState(state.contactMethods.deleteApi);
    },
    deleteContactMethodsSuccess(state, action) {
      state.contactMethods.data = setSuccessState(
        state.contactMethods.deleteApi,
        action.payload[0],
      );
    },
    deleteContactMethodsFailure(state, action) {
      setFailureState(
        state.contactMethods.deleteApi,
        action.payload.data,
        action.payload.statusText,
      );
    },
    resetCreateContactMethodsApi(state) {
      state.contactMethods.createApi = { ...initialApiState };
    },
    resetUpdateContactMethodsApi(state) {
      state.contactMethods.updateApi = { ...initialApiState };
    },
  },
});

export const actions = contactMethodsSlice.actions;

export default contactMethodsSlice.reducer;
